export const INSTRUCTOR_LEVELS = [
  { value: "Dive Leader", labelKey: "instructorLevels.DiveLeader" },
  { value: "Instructor", labelKey: "instructorLevels.Instructor" },
  { value: "Advanced/Specialist", labelKey: "instructorLevels.AdvancedSpecialist" },
  { value: "Technical Instructor", labelKey: "instructorLevels.TechnicalInstructor" },
  { value: "Instructor Trainer", labelKey: "instructorLevels.InstructorTrainer" },
  { value: "Director - Assessor Examiner", labelKey: "instructorLevels.Director" },
];

// Instructor levels authorized to issue specialist professional certifications.
export const TRAINER_LEVELS = [
  "Instructor Trainer",
  "Course Director Assessor",
  "Director - Assessor Examiner",
];

export const isTrainerLevel = (level) => TRAINER_LEVELS.includes(level);

export const levelLabel = (t, value) => {
  const level = INSTRUCTOR_LEVELS.find((l) => l.value === value);
  return level ? t(level.labelKey) : value || "—";
};

export const INSTRUCTOR_REGIONS = [
  "Slovakia",
  "Poland",
  "Spain",
  "Malaysia",
  "Singapore",
  "Indonesia",
  "Borneo",
  "UK",
  "Benelux",
  "Italy",
  "Greece",
  "Malta",
  "USA",
  "China",
  "Ireland",
  "Denmark",
  "Greenland",
  "Sweden",
  "Norway",
  "Brunei",
  "Egypt",
  "Turkey",
  "Caribbean",
  "Bahamas",
  "Mexico",
  "South America",
  "Canada",
  "Other",
];

export const CROSSOVER_AGENCIES = [
  { value: "ITDA", labelKey: "crossoverAgencies.ITDA" },
  { value: "PADI", labelKey: "crossoverAgencies.PADI" },
  { value: "TDI/SDI", labelKey: "crossoverAgencies.TDI_SDI" },
  { value: "RAID", labelKey: "crossoverAgencies.RAID" },
  { value: "CMAS", labelKey: "crossoverAgencies.CMAS" },
  { value: "FEDAS/SUF", labelKey: "crossoverAgencies.FEDAS_SUF" },
  { value: "NAUI", labelKey: "crossoverAgencies.NAUI" },
  { value: "PSA", labelKey: "crossoverAgencies.PSA" },
  { value: "IANTD", labelKey: "crossoverAgencies.IANTD" },
  { value: "BSAC", labelKey: "crossoverAgencies.BSAC" },
  { value: "Other", labelKey: "crossoverAgencies.Other" },
];